import { api } from '@koridor/api-client';
import { isRematchDismissed, rematchSourceId } from './rematch';

let wired = false;

export async function ensureNotificationPermission(): Promise<NotificationPermission | 'unsupported'> {
  if (typeof Notification === 'undefined') return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    return await Notification.requestPermission();
  } catch {
    return 'denied';
  }
}

export function showBrowserNotification(title: string, body: string, data?: Record<string, string>) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title, { body, tag: 'koridor', data });
    n.onclick = () => {
      window.focus();
      if (data?.rematchFrom) window.location.assign(`/result?rematchFrom=${data.rematchFrom}`);
      else if (data?.matchId) window.location.assign(`/game`);
      n.close();
    };
  } catch {
    /* ignore */
  }
}

/** Wire WS events to browser notifications when user opted in. */
export function wireMatchNotifications(enabled: boolean) {
  if (!enabled || wired) {
    if (!enabled && wired) {
      wired = false;
    }
    return () => {};
  }
  wired = true;
  const offFound = api.on('matchmaking.found', () => {
    showBrowserNotification('Коридор', 'Соперник найден — можно играть');
  });
  const offInvite = api.on('invite.received', (payload: unknown) => {
    const from = (payload as { fromUser?: { nickname?: string } })?.fromUser?.nickname ?? 'Игрок';
    showBrowserNotification('Коридор', `${from} приглашает вас в партию`);
  });
  const offRematch = api.on('rematch.offered', (payload: unknown) => {
    const p = payload as { fromUser?: { nickname?: string }; sourceMatchId?: string; matchId?: string };
    const matchId = rematchSourceId(p);
    if (!matchId || isRematchDismissed(matchId)) return;
    const from = p?.fromUser?.nickname ?? 'Соперник';
    showBrowserNotification('Коридор', `${from} предлагает реванш`, { rematchFrom: matchId });
  });
  const offTurn = api.on('match.state', (payload: unknown) => {
    const p = payload as { yourTurn?: boolean; matchId?: string };
    if (p.yourTurn) {
      showBrowserNotification('Коридор', 'Ваш ход', { matchId: p.matchId ?? '' });
    }
  });
  return () => {
    offFound();
    offInvite();
    offRematch();
    offTurn();
    wired = false;
  };
}
